<template>

    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                    <div class="card-header card-header-info">
                        <h4 class="card-title ">Tambah {{data.page}}</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Nama </label>
                                        <input type="text" class="form-control" placeholder="Keterangan..." v-model="data.nama">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Jumlah Port</label>
                                        <input type="number" class="form-control" placeholder="Jumlah..." v-model="data.port" min="0">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Jumlah Port (Opsional) <button class="btn btn-sm btn-primary" @click="data.modalODC = true">Pilih ODC</button></label>
                                        <input type="text" class="form-control" placeholder="ODC..." v-model="data.odcnama" min="0" disabled>
                                        <input type="hidden" class="form-control" placeholder="ODC..." v-model="data.odcid" min="0">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Lokasi (Geser Marker merah untuk mengganti lokasi)</label>
                                        <input type="text" class="form-control mb-2" placeholder="Koordinat..." v-model="data.markerLatLng" min="0" disabled>
                                        
                                        
                                        <div class="row" style="height: 300px">
                                            <l-map  ref="map"
                                                :zoom="data.zoom"
                                                :center="data.center"
                                                :options="data.mapOptions"
                                                style="height: 100%"
                                                @update:center="map.centerUpdate"
                                                @update:zoom="map.zoomUpdate"
                                                @ready="map.doSomethingOnReady()"
                                                >
                                                <l-tile-layer
                                                :url="data.url"
                                                :attribution="data.attribution"
                                                />

                                            </l-map>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                            <div class="form-group">
                                <button class="btn btn-primary" @click="form.simpan()">Simpan</button>
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalODC">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Pilih ODC</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalODC = false">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                    <div class="col-md-12" style="height: 400px;overflow:auto">
                        <div class="table-responsive">
                        <table class="table">
                            <thead class=" text-info">
                            <th>No.</th>
                            <th>Nama</th>
                            <th>Aksi</th>
                            </thead>
                            <tbody>
                                <tr v-for="(u, index) in data.odcList">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ u.nomor }}</td>
                                    <td>
                                    <button class="btn btn-sm btn-primary" @click="form.pilihODC(u.id,u.nomor)"> Pilih</button> <!-- @click="cariByAdmin(u.nama)" -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 


import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LIcon } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		moment,
		LMap,
		LTileLayer,
		LMarker,
		LPopup,
		LTooltip,
        LIcon
	}, 
    props: {
        options: {type: Object, default: () => {}},
    },
    setup() {
        const data = reactive({
            markers: [],
            // ODC
            odcList: [],
            modalODC: false,
            odcnama: "",
            odcid: null,

            dis: '',
            
            nama: '',
            port: '',

            params: null,
            page: null,

            // MAP
            
			zoom: 12,
			center: [-0.2664523,115.8973852],
			url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			attribution:
				'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			withPopup: latLng(-8.102982, 113.222425),
			currentZoom: 11.5,
			showParagraph: false,
			mapOptions: {
				closePopupOnClick: false,
                doubleClickZoom: 'center',
				zoomSnap: 0.5
			},
            centerMap: null,
            markerLatLng: null,
            markerLat: null,
            markerLng: null

        })

        const map = {
            d: reactive({
                map: [],
            }),
            
            doSomethingOnReady() {
                var xx = data;
                this.d.map = data.dis.$refs.map.mapObject;



                map.getData();
                
            },
            markere() {
                
                data.centerMap =  this.d.map.getCenter();
                console.log(JSON.stringify(data.centerMap));
                data.markers.push(data.centerMap);

                var marker = L.marker(new L.LatLng(data.centerMap.lat, data.centerMap.lng), {
                    draggable: true,
                    icon: map.getMarkerIcon(L, "red")
                }).addTo(this.d.map);

                marker.on('dragend', function (e) {
                    //console.log(marker.getLatLng().lat+", "+marker.getLatLng().lng);

                    data.markerLatLng = marker.getLatLng().lat+", "+marker.getLatLng().lng;
                    data.markerLat = marker.getLatLng().lat;
                    data.markerLng = marker.getLatLng().lng;

                    //document.getElementById('latitude').value = marker.getLatLng().lat;
                    //document.getElementById('longitude').value = marker.getLatLng().lng;
                })
            },
            getMarkerIcon(L, color) {
                return L.icon({
                    iconUrl: "https://beatcom.web.id/assets/marker.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                })
            },
            zoomUpdate(zoom) {
                data.currentZoom = zoom;
            },
            centerUpdate(center) {
                //console.log(lat);
                data.currentCenter = center;
            },
            showLongText() {
                data.showParagraph = !data.showParagraph;
            },

            getPosition: function(lat,lng) {
                return {
                    lat: lat,
                    lng: lng
                }
            },
            
            getData() {
                var data = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    page: "ODP"
                }
                
                var apiUrl = inter.ODPList();
                myGlobal.call(data,apiUrl).then(x => {
                    
                    if (x.status == true) {
                    this.marker = x.data;

                    if (x.data.length > 0) {
                        map.d.map.setView(new L.latLng(this.marker[0].lat, this.marker[0].lng));

                        map.markere();
                    }

                    } else {

                    //alert(x.pesan);

                    }
                })
            },
        }

        const form = {
            pilihODC(id,nama) {
                data.odcnama = nama;
                data.odcid = id;
                data.modalODC = false;

                // console.log(data.odcnama);
            },
            getodc() {
                //console.log(sessionStorage.getItem('admin'));
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                };
            
                var apiUrl = inter.ODCODPList();
                myGlobal.call(datax,apiUrl).then(x => {
                    // console.log(JSON.stringify(x));
                    if (x.status == true) {
                        data.odcList = x.data;

                    } else {
                        //alert(x.pesan);
                    }
                })
            },
            simpan() {
                if (data.nama == "") {
                    alert("Nomor tidak boleh kosong");
                    return false;
                }
                if (data.port == "") {
                    alert("Port tidak boleh kosong");
                    return false;
                }
                if (data.markerLatLng == "") {
                    alert("Koordinat tidak boleh kosong");
                    return false;
                }

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    nomor: data.nama,
                    port: data.port,
                    page: data.params.page,
                    lat: data.markerLat,
                    lng: data.markerLng
                };
                
                if (data.page == "odp") {
                    if (data.odcid != null) {
                        datax.odc = data.odcid;
                    }
                }
            
                var apiUrl = inter.ODCODPTambah();
                myGlobal.call(datax,apiUrl).then(x => {
                    if (x.status == true) {

                        location.href="#/odcodp"
                    
                    } else {
                        
                    }
                })
            }
        }
        return {
            map,
            data,
            myGlobal,
            form,
            latLng
        }
    },
    
	mounted() {
		this.data.params = this.$route.params;

        if (!myGlobal.RootOnly()) {
            this.$router.go(-1);
        }

        //console.log(JSON.stringify(this.data.params));
        var page = this.data.params.page;
        this.data.page = page;

        if (page == "odp") {
            //alert("ini O D P");
        }

        this.data.dis = this;
        this.form.getodc();
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/odcodp/tambah.vue